// removed by extract-text-webpack-plugin
module.exports = {"root":"Accordion__root___346_j","item":"Accordion__item___V0jCR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseAccordion/Accordion/Accordion.scss
// module id = 1004
// module chunks = 0